import { useHistory } from 'modules/Editor/store/history/historyManager';
import { ToastContent, useToast } from 'modules/common/components/Toast';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

export const useResizedToast = () => {
  const toast = useToast();
  const { undo } = useHistory();
  const { t } = useTranslation('editor_toolbar');

  const toastId = useId();

  const handleClick = () => {
    if (undo) undo();
    toast.close(toastId);
  };

  const showToast = () => {
    toast({
      id: toastId,
      title: t('message.pageResized'),
      render: ({ title }) => <ToastContent title={title} buttonTitle={t('undoBtn.text')} handleClick={handleClick} />,
    });
  };

  return { showToast };
};
